export default "https://cdn-static.gokick.com/assets/a067049b7600101c8dd9c58c97ab0ac81c37d227/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";